import { createContext } from 'react';
import { ISearchResult } from './searchResult';

export type SearchResultsContextProps = {
  searchResult: ISearchResult;
  setSearchResult: Function;
};

export const SearchResultsContext = createContext({} as SearchResultsContextProps);
